<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    id: {
      type: String,
      value: "",
    },
    typeId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "work",
      key: "id",
      url: {},
      items: [
        {
          label: "转单",
          name: "maintainerId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "维修员不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
      ],
      forms: {
        id: this.id,
      },
    };
  },
  created() {
    this.loaduserData();
  },
  methods: {
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/receive/editTransfer`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                location.reload();
              }, 200);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                location.reload();
              }, 200);
            });
        }
      });
    },
    loaduserData() {
      // 通过pk查询字典数据
      $utils.api.load(`/admin/system/maiUser/consumableList`, {}, "get").then((res) => {
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "maintainerId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
  },
};
</script>
